/**
 * Client-side completion check for layout/sidebar (not authoritative for routing).
 * Server flag `requires_2fa_setup` from GET /auth/me drives setup redirects.
 */
export function userHasCompletedTwoFactorSetup(user: unknown): boolean {
  if (!user || typeof user !== 'object') {
    return false
  }
  const u = user as Record<string, unknown>
  if (u.two_factor_enabled === true) {
    return true
  }
  if (u.has_two_factor === true) {
    return true
  }
  const confirmed = u.two_factor_confirmed_at
  if (confirmed !== null && confirmed !== undefined && confirmed !== '') {
    return true
  }
  return false
}

/** True when API explicitly says the user must complete 2FA enrollment. */
export function userRequiresTwoFactorSetupFromServer(user: unknown): boolean {
  if (!user || typeof user !== 'object') {
    return false
  }
  return (user as { requires_2fa_setup?: boolean }).requires_2fa_setup === true
}
